import React, { useEffect, useState } from "react";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Btn } from "../../../AbstractElements";
import { useGetAgendaControlType } from "../../Configuration/Agenda/UseAgenda";
import { useGetAgendaSubType } from "../../ProductCatalogue/BrandCampaignStep/useBrandCampaignStep";
import {Update_MTP_Tour_Plan,useAdd_MTP_Tour_Plan,useGetTerritory,useMtpDayBeatTown,useMTPDayCustomers,} from "../hooks/useMTP";
import { useLocation } from "react-router-dom";
import { useBeatData } from "../../FSM/Beats_Patches/hooks/useBeat";

interface rowDataInterface {
  working: string;
  Agenda: string;
  AgendaId: number;
  Beat_Town: string;
  BeatId: number;
  Customer: string;
  Tags: string | null;
  Vf: number;
  Focus_Brand: string | null;
  JW: string;
  OutletOrgDataId: number;
  PositionId: number;
  OrgUnitId: number;
  OrgUnitName: string;
  MtpDayId: string | number;
  BeatName: string;
  TownName: string;
  TerritoryId?: number | string;
  TpId?:number
}

interface MtpdayTourModalPop {
  status: string;
  onCancel: () => void;
  rowData: rowDataInterface;
  OrgUnitId: number | undefined;
  working: string | undefined;
  positionId: number | undefined;
}
interface FomrdataInitalValueInterface {
  Agenda: string | number;
  Sub_Agenda: string | number;
  Territory: string | number;
  Patch: string | number;
  Customers: string | number;
  townId: string | number;
}

const MtpdayTourModal: React.FC<MtpdayTourModalPop> = ({
  positionId,
  working,
  OrgUnitId,
  status,
  onCancel,
  rowData,
}) => {
  const location = useLocation();
  const { mtpDayRowData } = location?.state || {};  
  useEffect(() => {
    if (status === "Edit" && rowData) {
      setFormaData((prev: any) => ({
        ...prev,
        Agenda: rowData.working,
        Sub_Agenda: rowData.AgendaId,//old one
        // Sub_Agenda: rowData.Agenda,
        // Territory:'',
        Territory: rowData.TerritoryId,
        // Patch:rowData.BeatName,
        Patch: rowData.BeatId,
        Customers: rowData.OutletOrgDataId,
        townId: rowData.TownName || "-",
      }));
    }
  }, [rowData]);

  const mtpDayID_route: number = mtpDayRowData?.MtpDayId;
  const FomrdataInitalValue: FomrdataInitalValueInterface = {
    // inital values
    Agenda: "",
    Sub_Agenda: "",
    Territory: "",
    Patch: "",
    Customers: "",
    townId: "",
  };


  const [formDAta, setFormaData] = useState<FomrdataInitalValueInterface>(FomrdataInitalValue);
  const {data: AgendaControlTypeData,isLoading: AgendaControlTypeIsloading,isSuccess: AgendaControlTypeIssuscess,} = useGetAgendaControlType({ enabled: true });
  const { mutate: addMTPTourPlan } = useAdd_MTP_Tour_Plan();
  const { mutate: updateTourPlan } = Update_MTP_Tour_Plan();

  const [TerritoryId, setTerritoryId] = useState<number | undefined>(undefined);
  const [BeatID_For_customer, setBeatID_For_customer] = useState<number | undefined>(undefined);
  const [agenda_for_subAgendaDropDown, setagenda_for_subAgendaDropDown] = useState<string | undefined>(undefined);
  const isReady = Boolean(OrgUnitId && agenda_for_subAgendaDropDown != undefined);

  const {data: AgendaSubType,isLoading: AgendaSubTypeisloading,isSuccess: AgendaSubTypeIssuccess,} = useGetAgendaSubType({
    enable: status === "Edit" ? true : isReady,
    params: {
      Orgunitid: OrgUnitId,
      agendaType:
        status !== "Edit" ? agenda_for_subAgendaDropDown : rowData.working, //isPrivate key true then it get the data GetAgendaSubType // don't uncomment  //
      // agendaType:agenda_for_subAgendaDropDownS,
    },
  });

  const {data: MTPTerritory,isLoading: MTPTerritoryIsLoading,isSuccess: MTPTerritoryIsSuccess,} = useGetTerritory({ enable: !!positionId, positionID: Number(positionId) });

  //Customer Drop_Down Data
  const {isLoading,isSuccess,data: MtpDayCustomersData,} = useMTPDayCustomers({
    enable: !isNaN(mtpDayID_route),
    mtpDayId: mtpDayRowData?.MtpDayId as number,
    beatID: status !== "Edit" ? BeatID_For_customer : rowData.BeatId,
  });

  // Towns Drop Down data
  const {isLoading: MtpDayBeatTownisLoading,isSuccess: MtpDayBeatTownIsSuccess,data: MtpDayBeatTownData,} = useMtpDayBeatTown({
    enable: !!mtpDayID_route,
    mtpDayId: mtpDayID_route,
    agendaControlType: agenda_for_subAgendaDropDown,
  });

  const isEnabled = () => {
    if (status === "Edit") {
      return !!rowData.TerritoryId;
    }
    return TerritoryId !== undefined;
  };
  
  const {data: PatchDropDownData,isLoading: PatchDropDownDataIsLoading,isSuccess: PatchDropDownDataIsLoadingIssuccess,} = useBeatData({
    enable: isEnabled(),
    params: {
      TerritoryId: status === "Edit" ? (rowData.TerritoryId =="-"?"":rowData.TerritoryId) : TerritoryId,
    },
  });

  const formatedDataForPatchDropDown = Array.isArray(PatchDropDownData?.data?.data)
    ? PatchDropDownData.data.data.map((item: any) => ({
        id: item.BeatId || "-",
        label: item.BeatName || "-",
      }))
    : [];

  const formatedData = Array.isArray(
    MtpDayCustomersData?.rowData?.data.CustomersList
  )
    ? MtpDayCustomersData.rowData.data.CustomersList.map((item: any) => ({
        id: item.OutletOrgId || "-",
        label: item.OutletName || "-",
      }))
    : [];

  const formatedData_MtpDayBeatTown = Array.isArray(
    MtpDayBeatTownData?.rowData.data.BeatTownData
  )
    ? MtpDayBeatTownData.rowData.data.BeatTownData.map((item: any) => ({
        id: item.Itownid || "-",
        label: item.BeatName || "-",
        //   TownName:item.BeatTownName ||'-'
      }))
    : [];
  const handleSumbitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (status == "add") {
      addMTPTourPlan({
        mtpDayId: mtpDayID_route, // via get API
        agendaControlType: formDAta.Agenda as string,
        agendaId: Number(formDAta.Sub_Agenda), // sub-agenda
        territoryId: Number(formDAta.Territory),
        townId: formDAta.townId === "" ? null : Number(formDAta.townId),
        beatId: Number(formDAta.Patch),
        outletOrgDataId: Number(formDAta.Customers), // via get API
      });
    }

    if (status == "Edit") {
      updateTourPlan({
        mtpDayId:Number(rowData.MtpDayId), 
        tourplanId:Number(rowData.TpId),

        agendaControlType:String(formDAta.Agenda),
        agendaId: Number(formDAta.Sub_Agenda),
        territoryId:Number(formDAta.Territory),

        townId: formDAta.Agenda == "NCA" ? Number(formDAta.townId) : undefined,
        beatId: Number(formDAta.Agenda == "FW" || formDAta.Agenda =="JW" ? formDAta.Patch: undefined),

        outletOrgDataId:Number(formDAta.Customers),
      });
    }
    setFormaData(FomrdataInitalValue);
    onCancel();
  };
  const InputHanlder = (key: keyof FomrdataInitalValueInterface, val: any) => {
    setFormaData((prev: any) => ({
      ...prev,
      [key]: val,
    }));
  };
   
return (
    <form onSubmit={handleSumbitForm}>
      <ReusableDropdown
        value={formDAta.Agenda}
        onChange={(val: any) => {
          InputHanlder("Agenda", val);
          // alert(JSON.stringify(val));
          setagenda_for_subAgendaDropDown(val);
        }}
        options={
          (!AgendaControlTypeIsloading &&
            AgendaControlTypeIssuscess &&
            AgendaControlTypeData?.data) ||
          []
        }
        DropdownHeading="Agenda"
      />

      <ReusableDropdown
        value={formDAta.Sub_Agenda}
        onChange={(val: any) => {
          InputHanlder("Sub_Agenda", val);
          // console.log('Sub_Agenda dropDown===>',val);
        }}
        options={
          (!AgendaSubTypeisloading &&
            AgendaSubTypeIssuccess &&
            AgendaSubType?.data) ||
          []
        }
        DropdownHeading="Sub Agenda"
      />

      <ReusableDropdown
        value={formDAta.Territory}
        onChange={(val: any) => {
          InputHanlder("Territory", val);
          setTerritoryId(val);
        }}
        options={
          (!MTPTerritoryIsLoading &&
            MTPTerritoryIsSuccess &&
            MTPTerritory?.formatedData) ||
          []
        }
        DropdownHeading="Territory"
      />

      {agenda_for_subAgendaDropDown !== "NCA" ? (
        <>
          <ReusableDropdown
            value={formDAta.Patch}
            onChange={(val: any) => {
              console.log('Patch====>',val);
              InputHanlder("Patch", val);
              setBeatID_For_customer(val);
            }}
            options={
              (!MtpDayBeatTownisLoading &&
                MtpDayBeatTownIsSuccess &&
                formatedDataForPatchDropDown) ||
              []
            }
            DropdownHeading="Patch"
          />

          <ReusableDropdown
            value={formDAta.Customers}
            onChange={(val: any) => InputHanlder("Customers", val)}
            options={(!isLoading && isSuccess && formatedData) || []}
            DropdownHeading="Customers"
          />
        </>
      ) : (
        <>
          <ReusableDropdown
            value={formDAta.townId}
            options={
              (!MtpDayBeatTownisLoading &&
                MtpDayBeatTownIsSuccess &&
                formatedData_MtpDayBeatTown) ||
              []
            }
            onChange={(val: any) => InputHanlder("townId", val)}
            DropdownHeading="Town"
          />
        </>
      )}

      <div style={{ height: 10, marginTop: "10px" }} />

      <div className="d-flex justify-content-start gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          {status === "add" ? "Submit" : "Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={() => {
            onCancel();
            setFormaData(FomrdataInitalValue);
          }}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default MtpdayTourModal;
